/**
 * Simple logging utility for client-side
 * PATTERN-001: Structured logging with context
 */

interface LogContext {
  [key: string]: any;
}

export function logInfo(message: string, context?: LogContext) {
  console.log(`[INFO] ${message}`, context || "");
}

export function logError(message: string, error: any, context?: LogContext) {
  console.error(`[ERROR] ${message}`, error, context || "");
}

export function logWarning(message: string, context?: LogContext) {
  console.warn(`[WARN] ${message}`, context || "");
}
